import clsx from 'clsx'

type Props = {
  className?: string
}

export const MouseWheelAnimation = ({ className }: Props) => (
  <div
    className={clsx(
      'absolute top-1/2 h-4 w-6 -translate-y-1/2 rounded-lg border-2 border-fv-blue-200 bg-white',
      className,
    )}
  >
    <div className="absolute top-1/2 h-[0.3rem] w-[0.5rem] -translate-y-1/2 rounded-full bg-fv-blue animate-mouseWheel" />
  </div>
)
